module.exports = __webpack_public_path__ + "static/img/coins.7fc3718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/account/coins.png
// module id = ppk7
// module chunks = 0